export default "__VITE_ASSET__DNBG_Z$z__"